var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48667 13.1333C5.03333 12.5467 5.86667 12.5933 6.34667 13.2333L7.02 14.1333C7.56 14.8467 8.43333 14.8467 8.97333 14.1333L9.64667 13.2333C10.1267 12.5933 10.96 12.5467 11.5067 13.1333C12.6933 14.4 13.66 13.98 13.66 12.2067V4.69333C13.6667 2.00667 13.04 1.33333 10.52 1.33333H5.48C2.96 1.33333 2.33333 2.00667 2.33333 4.69333V12.2C2.33333 13.98 3.30667 14.3933 4.48667 13.1333Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.66667L10 4.66667",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99634 8.66667H10.0023",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99634 5H6.00233",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptDiscount);
export default __webpack_public_path__ + "static/media/receipt-discount.f195ff88cf4b9fb1cde68661bace3303.svg";
export { ForwardRef as ReactComponent };